export const ChartEventMixins = {
  methods: {
    handleClick(event, chart) {
      this.handleEvent('click', event, chart)
    },
    handleReturn(){
      this.$emit('return')
    },
    handleEvent(eventName, event, chart) {
      this.$emit(eventName, event, chart)
    },
  }
}